/**
 * itSupport.js
 *
 * PIN reset requests are sent via the Functions API (app-only Graph mail).
 * No delegated Mail.Send scope is required in the browser.
 */

import { requestPinReset } from './client.js';

/**
 * Send a PIN reset request to IT support on behalf of the signed-in user.
 *
 * @param {object} user  — { name, email, role, clinicObjects?, region? }
 * @param {string} note  — optional free-text note from the user
 */
export async function sendPinResetRequest(user, note = '') {
  if (!user?.email) throw new Error('Missing user email.');
  const clinic = user.clinicObjects?.[0]?.name || user.region || '';
  return requestPinReset({ note, clinic });
}
